import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2ImportProcService {
    constructor(private dataTask: DataTaskService) {}

    /** @datatask 878 */
    public async getImportProcedure(params: { p2_importproc_keyno: string | number }): Promise<P2ImportProcedureGet> {
        return (await this.dataTask.Post(878, params))[0];
    }

    /** @datatask 880 */
    public async detectFileProcedure(params: { filename: string; filecontent: string; origin: 'FILE'; getmethod: 'MANUAL' }): Promise<P2ImportFileGet> {
        return (await this.dataTask.Post(880, params))[0];
    }

    /**
     * @datatask 877
     * @datataskName sp_ws_p2_p2importproc_list
     * @param params Import procedure list filters.
     * @returns Promise containing the available import procedures.
     */
    public getImportProceduresList(params: P2ImportProcListParams): Promise<P2ImportProcListItem[]> {
        return this.dataTask.Post(877, params);
    }
}

export interface P2ImportProcListParams {
    show_in_excelimport?: '0' | '1' | 'A';
}

export interface P2ImportProcListItem {
    item_id: string | number;
    item_name: string;
}
export interface P2ImportProcedureGet { show_table_name_destination: '0' | '1'; }
export interface P2ImportFileGet { p2_importproc_keyno: string | number; encodingtype: string; }
